import config from "../../config";
import { apiFetch, createMultiConsumerGet } from "./apiFetch";

const getAccountId = () => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user.accountId;
};

const buildUrl = (path, params = {}) => {
    const filtered = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const qs = new URLSearchParams({ account_id: getAccountId(), ...filtered });
    return `${config.apiUrl}/${path}?${qs}`;
};

const sharedGet = createMultiConsumerGet(async (url, options) => {
    const res = await apiFetch(url, options);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
});

const get = (path, params = {}, options = {}) =>
    sharedGet(buildUrl(path, params), options);

// ─── Chart of Accounts ───────────────────────────────────────

export const getChartOfAccounts = (params = {}, options = {}) =>
    get("getChartOfAccounts", params, options);

export const getChartOfAccountById = (id, options = {}) =>
    get("getChartOfAccountById", { id }, options);

export const createChartOfAccount = async (data) => {
    const res = await apiFetch(`${config.apiUrl}/createChartOfAccount`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ account_id: getAccountId(), ...data }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
};

export const updateChartOfAccount = async (id, data) => {
    const res = await apiFetch(`${config.apiUrl}/updateChartOfAccount`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ account_id: getAccountId(), id, ...data }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
};

export const deleteChartOfAccount = async (id) => {
    const res = await apiFetch(buildUrl("deleteChartOfAccount", { id }), { method: "DELETE" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
};

// ─── Helper: dropdown options for Payment Voucher ────────────

/** Bank/cash accounts for "Pay From" dropdown */
export const getBankAccountOptions = async () => {
    const res = await getChartOfAccounts({ is_bank_account: true, is_active: true });
    const rows = res?.data || res || [];
    return rows.map((a) => ({
        value: a.id,
        label: `${a.account_code} — ${a.account_name}`,
        raw: a,
    }));
};

/** Expense accounts for PV line items */
export const getExpenseAccountOptions = async () => {
    const res = await getChartOfAccounts({ account_type: "Expense", is_active: true });
    const rows = res?.data || res || [];
    return rows.map((a) => ({
        value: a.id,
        label: `${a.account_code} — ${a.account_name}`,
        raw: a,
    }));
};